import React, {Component} from "react"
import PropTypes from "prop-types"
import {isEqual} from "lodash"

import id from "@irati/utils/id"
import CommentsQuery from "@irati/insights/apollo/query/comment/list"
import {CommentsContext, AnalysisContext} from "@irati/insights/context"
import GetCommentTagCountQuery from "@irati/insights/apollo/query/comment/getTagCount"
import {overrideAuth} from "@irati/insights/utils/apollo"

import CommentsTable from "./CommentsTable"
import {BOOKMARK_TYPE, BOOKMARK_TYPE_TAG_VALUE} from "../../utils/constants/comment"

class CommentsController extends Component {
  static propTypes = {
    filters: PropTypes.object,
    tenant: PropTypes.string,
    cycle: PropTypes.object.isRequired
  }

  static defaultProps = {
    filters: [],
    tenant: null
  }

  state = {page: 0, bookmark: null, sentiment: null}

  componentDidUpdate({filters: oldFilters}) {
    const {filters} = this.props
    if (!isEqual(oldFilters, filters)) {
      this.handlePageChange(0)
    }
  }

  handleFilterUpdate = (value, property) => {
    if (!property) {
      this.setState({bookmark: null, sentiment: null, page: 0})
    } else {
      this.setState({[property]: value, page: 0})
    }
  }

  handlePageChange = (nextPage) => {
    this.setState({page: nextPage})
  }

  render() {
    return (
      <AnalysisContext.Consumer>
        {({isDemo, demoTenantAccessToken}) => {
          const idNamespace = id("comments", this.props)
          const {filters, tenant, cycle} = this.props
          const {page, bookmark, sentiment} = this.state
          const commentsFilters = {bookmark, sentiment}

          const commentsQueryParams = {cycle, tenant, page, filters: {...filters, ...commentsFilters}}
          const tagCountQueryParams = {cycle, tenant, tagType: BOOKMARK_TYPE, tagValue: BOOKMARK_TYPE_TAG_VALUE}

          return (
            <GetCommentTagCountQuery {...tagCountQueryParams} useLoader={false} {...overrideAuth(demoTenantAccessToken, isDemo)}>
              {({tagCount: {results: allBookmarks = []}}) => {
                return (
                  <CommentsQuery
                    {...commentsQueryParams}
                    useLoader={false}
                    fetchPolicy="network-only"
                    {...overrideAuth(demoTenantAccessToken, isDemo)}>
                    {({comments: {results: comments = [], total = 0}, loading}) => {
                      return (
                        <CommentsContext.Provider
                          value={{
                            comments,
                            sentiment,
                            bookmark,
                            commentsFilters,
                            allBookmarks,
                            loading,
                            total,
                            page,
                            onPageChange: this.handlePageChange,
                            updateFilter: this.handleFilterUpdate
                          }}>
                          <CommentsTable id={idNamespace} />
                        </CommentsContext.Provider>
                      )
                    }}
                  </CommentsQuery>
                )
              }}
            </GetCommentTagCountQuery>
          )
        }}
      </AnalysisContext.Consumer>
    )
  }
}

export default CommentsController
